import { render } from "./TablaCursos.vue?vue&type=template&id=3f891d9e&ts=true"
import script from "./TablaCursos.vue?vue&type=script&lang=ts"
export * from "./TablaCursos.vue?vue&type=script&lang=ts"

import "./TablaCursos.vue?vue&type=style&index=0&id=3f891d9e&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__